<template>
  <v-card>
    <GenericListTable
      :parentID="this.parentID"
      :title="`Project Groups`"
      :headers="[
        { text: 'ID', value: 'id' },
        { text: 'Project Group Name', value: 'groupname' },
        { text: 'Project Group Description', value: 'description' }
      ]"
      :url="`/schemas/projectgroups`"
      :apiResponseField="`projectgroups`"
      :onClickRoute="`ProjectGroupSingle`"
      :onClickParams="getOnClickParams">
    </GenericListTable>
  </v-card>
</template>

<script>
import GenericListTable from '@/components/Common/GenericListTable'
export default {
  name: 'ProjectGroupListTable',
  components: { GenericListTable },
  props: {
    parentID: {
      type: Number,
      default: null
    }
  },
  methods: {
    getOnClickParams (item) {
      return {
        id: item.id
      }
    }
  }
}
</script>
